var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"sk-chase"},[_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"}),_c('div',{staticClass:"sk-chase-dot"})])])
}]

export { render, staticRenderFns }